module.exports = __webpack_public_path__ + "img/PetLogo.7241601e.png";